/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from '@/api/axios.js'
import moment from './plugins/moment'
import '@/filter/filter.js'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import 'normalize.css'
// import './plugins/login.js'
import './plugins/element.js'
import './assets/css/global.less'
import './assets/css/loading.less'
import './assets/iconfont/iconfont.css'
import 'babel-polyfill'

Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(moment)

//去除页面所有警告
window.console.warn = () => {}

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.meta.requireAuth) {
        // 判断该路由是否需要登录权限
        if (store.state.userToken) {
            // 通过vuex state获取当前的userToken是否存在
            next()
        } else {
            next({
                path: '/login',
                query: { redirectUrl: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    } else {
        next()
    }
})

router.afterEach((to, from, next) => {
    NProgress.done()
        // if (!store.state.userToken) {
        //     if (!to.meta.requireAuth) {
        //         next()
        //     } else {
        //         next({
        //             path: '/login',
        //             query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        //         })
        //     }
        // } else {
        //     if (to.path !== '/login') {
        //         next()
        //     } else {
        //         next(from.fullPath)
        //     }
        // }
})

const vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

export default vue